var $jq = jQuery.noConflict();
var config = {
    ImageZoom: '',
    VariantImageSwitch: '',
    NextPreviousButtons: '', 
    ShowInventory: '',
    isMetafield: true, //(Not Found in DB)
    VendorName: '',
    isShopifyProductReview: true,  //(Not Found in DB)
    addToCartonCollection: true,  //(Not Found in DB)
    OneClickCheckout: '',
    RedirectToCart: '', //done
    isCallback: true,  //(Not Found in DB) 
    isProductVideo: true,  //(Not Found in DB)
    videoMetafieldNamespace: "video",  //(Not Found in DB)
    videoMetafieldKey: "video",  //(Not Found in DB)
    PopupHeight: '', //Not used
    isDisplayRating: true, //(Not Found in DB)
    RatingProvider: '', 
    IsSocialShare: '',
    ZoomType: '',
    InstockDisplay: '', //Not used
    IsAddToCartSuccessMessage:'',
  	AddToCartSuccessMessage:"",
    IsSocialShare_FB:'', 
    IsSocialShare_Twitter:'', 
    IsSocialShare_Linkedin:'', 
    IsSocialShare_Pinterest:''
}

var selectedVariantId;
var productHandle = [];
var productHandleArray = [];
var JsonReqObbjData = {};

$jq(document).ready(function () {
    $jq.ajax('https://app.anncode.com/GetMustacheScript', {
        success: function (data) {// success callback function
            JsonReqObbjData.FrontEndJsonObj = data.FrontEndJsonObj;
          
          	config.ImageZoom = JsonReqObbjData.FrontEndJsonObj.ImageZoom;
            config.VariantImageSwitch = JsonReqObbjData.FrontEndJsonObj.VariantImageSwitch;
            config.NextPreviousButtons = JsonReqObbjData.FrontEndJsonObj.NextPreviousButtons;
            config.ShowInventory = JsonReqObbjData.FrontEndJsonObj.ShowInventory;
            config.VendorName = JsonReqObbjData.FrontEndJsonObj.VendorName;
            config.OneClickCheckout = JsonReqObbjData.FrontEndJsonObj.OneClickCheckout;
            config.RedirectToCart = JsonReqObbjData.FrontEndJsonObj.RedirectToCart;
            config.RatingProvider = JsonReqObbjData.FrontEndJsonObj.RatingProvider;
            config.ZoomType = JsonReqObbjData.FrontEndJsonObj.ZoomType;
            config.PopupHeight = JsonReqObbjData.FrontEndJsonObj.PopupHeight;
            config.IsAddToCartSuccessMessage=  JsonReqObbjData.FrontEndJsonObj.IsAddToCartSuccessMessage;
            config.AddToCartSuccessMessage = JsonReqObbjData.FrontEndJsonObj.AddToCartSuccessMessage;
            config.InstockDisplay = JsonReqObbjData.FrontEndJsonObj.InstockDisplay;
            config.IsSocialShare = JsonReqObbjData.FrontEndJsonObj.IsSocialShare;
            config.IsSocialShare_FB  = JsonReqObbjData.FrontEndJsonObj.IsSocialShare_FB;
            config.IsSocialShare_Twitter = JsonReqObbjData.FrontEndJsonObj.IsSocialShare_Twitter;
            config.IsSocialShare_Linkedin = JsonReqObbjData.FrontEndJsonObj.IsSocialShare_Linkedin;
            config.IsSocialShare_Pinterest = JsonReqObbjData.FrontEndJsonObj.IsSocialShare_Pinterest;
          
          var isAction;
           if (config.OneClickCheckout == true) {
           isAction = '/checkout';
           }
           else { 
             isAction = '/cart';
           }
          	JsonReqObbjData.mustache = `
      <!-- Modal content -->
     <div class="modal__content">
        <span class="close__" onclick="closeQuickView()"><i class="fas fa-times"></i></span>
        <span style="display:none" class="swap__right" onclick="getNextProduct(currentHandle)"><i class="fas fa-chevron-right"></i></span>
        <span style="display:none" class="swap__left" onclick="getPrevProduct(currentHandle)"><i class="fas fa-chevron-left"></i></span>
        <div class="main__content">
			<div class="image__section">
           		
                  <div class="main__image">
                      <a href="#"><img src="{{ featured_image }}" align="absmiddle" itemprop="image" id="feature_image" /></a>
                  </div>
				<div class="image__thumbnail">
                  
                      <ul>
                          {{ #images }}
                          <li class="active thumbnail__box">
                              <a href="#"><img src="{{ . }}" onclick="changeMainImage(this.src)" /></a>
                          </li>
                          {{ /images }}
                      </ul>
                  
  				</div>

			</div>
          <div class="detail__section">
            <div class="product__name">{{ title }}</div>
            <div class="vendor__section" style="display:none">
              <div class="vendor__name">{{ { vendor }}}</div>
            </div>
			<div class="product__price">${globalFields.store_currency}{{price}}</div>
            <div class="product__cart__section">
<form action=${ isAction} enctype="multipart/form-data" id="AddToCartForm">
                
                    <div id="qv-variant-outer">
          			</div>
                    

					<div class="pt-1 add__to__cart">
                      <div class="selector-wrapper">
							<label>Quantity</label>
							<input id="Quantity" name="quantity" value="1" min="1" class="ac_qv_qty quantity-selector" type="number" />
					  </div>
                      
                      
                        <button id="AddToCart" class="add__to__cart__btn" onclick="cartAdd()">
                          Add to cart
                        </button>
                     </div>


              </form>
            </div>
            <div class="product__detail__section">{{ { description }}}</div>
            <div class="social__share__section">
              <div style="display:none" id="facebook__share" class="facebook__section">
                <a
                  class="__facebook"
                  href="https://www.facebook.com/lang=en?text= {{ title }}&amp;url={{ siteUrl }}{{ url }}"
                  target="_blank"
                >
                  <i class="fab fa-facebook-f"></i> Facebook
                </a>
              </div>
              <div style="display:none" id="twitter__share" class="twitter__section">
                <a
                  class="__twitter"
                  href="https://twitter.com/?lang=en?text= {{ title }}&amp;url={{ siteUrl }}{{ url }}"
                  target="_blank"
                >
                  <i class="fab fa-twitter"></i> Twitter
                </a>
              </div>
              <div style="display:none" id="linkedin__share" class="linkedin__section">
                <a
                  class="__linkedin"
                  href="https://in.linkedin.com/?url={{ siteUrl }}{{ url }}"
                  target="_blank"
                >
                  <i class="fab fa-linkedin-in"></i> LinkedIn
                </a>
              </div>
              <div style="display:none" id="pinterest__share" class="pinterest__section">
                <a
                  class="__pinterest"
                  href="https://in.pinterest.com/?url={{ siteUrl }}{{ url }}"
                  target="_blank"
                >
                  <i class="fab fa-pinterest-p"></i> Pinterest
                </a>
              </div>
            </div>
          </div>
        </div>
</div>
      
   `
//             JsonReqObbjData.mustache = data.mustacheObj;

            

            if(Shopify.theme.theme_store_id == '578'){
                $jq('.product__image-wrapper').each(function (index) { 
                 f = $jq(this).attr("href").split("/");
                    productHandle = f[f.length - 1].split("?")[0];
                    productHandleArray[index] = productHandle;
                    //$jq(this).after("<span class='quick-view' onclick=getProductInformation('"+productHandle+"') product-handle='"+productHandle+"'>Quick View</span>");
                    $jq(this).after('<div class="vg-quickview-btn-outer" style=""><button type="button" style="" class="vg-quick-view" data-toggle="modal" onclick=getProductInformation("' + productHandle + '",this) product-handle="' + productHandle + '"><i class="fa fa-search"></i> Quick View</button>');
                    $jq(this).parent().css('position', 'relative');
                    $jq(this).parent().mouseenter(function () {
                        $jq(this).find('.vg-quickview-btn-outer').show();
                    }).mouseleave(function () {
                        $jq(this).find('.vg-quickview-btn-outer').hide();
                    })
                });
               } else if (Shopify.theme.theme_store_id == '730') {
                $jq('.grid-product__image-wrapper a[href*="/products/"]').each(function (index) { 
                 f = $jq(this).attr("href").split("/");
                    productHandle = f[f.length - 1].split("?")[0];
                    productHandleArray[index] = productHandle;
                    //$jq(this).after("<span class='quick-view' onclick=getProductInformation('"+productHandle+"') product-handle='"+productHandle+"'>Quick View</span>");
                    $jq(this).after('<div class="vg-quickview-btn-outer" style=""><button type="button" style="" class="vg-quick-view" data-toggle="modal" onclick=getProductInformation("' + productHandle + '",this) product-handle="' + productHandle + '"><i class="fa fa-search"></i> Quick View</button>');
                    $jq(this).parent().css('position', 'relative');
                    $jq(this).parent().mouseenter(function () {
                        $jq(this).find('.vg-quickview-btn-outer').show();
                    }).mouseleave(function () {
                        $jq(this).find('.vg-quickview-btn-outer').hide();
                    })
                });
            } else {
                $jq('a[href*="/products/"]:not([href*=".jp"]):not(form a[href*="/products/"]):not(.related-products a[href*="/products/"]):not(.not-sca-qv a[href*="/products/"]):not([href*=".JP"]):not([href*=".png"]):not([href*=".PNG"]):not(.product-bottom a[href*="/products/"]):not(p.h3 a[href*="/products/"])').each(function (index) {
                    f = $jq(this).attr("href").split("/");
                    productHandle = f[f.length - 1].split("?")[0];
                    productHandleArray[index] = productHandle;
                    //$jq(this).after("<span class='quick-view' onclick=getProductInformation('"+productHandle+"') product-handle='"+productHandle+"'>Quick View</span>");
                    $jq(this).after('<div class="vg-quickview-btn-outer" style=""><button type="button" style="" class="vg-quick-view" data-toggle="modal" onclick=getProductInformation("' + productHandle + '",this) product-handle="' + productHandle + '"><i class="fa fa-search"></i> Quick View</button>');
                    $jq(this).parent().css('position', 'relative');
                    $jq(this).parent().mouseenter(function () {
                        $jq(this).find('.vg-quickview-btn-outer').show();
                    }).mouseleave(function () {
                        $jq(this).find('.vg-quickview-btn-outer').hide();
                    })
                });
                 }
            if(data.message == "App Disabled"){
                $jq('.vg-quick-view').hide();
                }
                $jq('.share-title,.social-sharing').find('.vg-quick-view').hide();
        }
    });
});



//code to append Quickview button
var selectedVariantId;
var currentHandle;

function opens() {
    $.colorbox({
        inline: true,
        href: "#ac__my__Modal",
        width: '80%',
        height: config.containerHeight
    });
}
//onclick Quickview button

function getNextProduct(currentHandle) {
    var len = $jq('.vg-quick-view').length;
    var nextIndex;

    var currentIndex = productHandleArray.indexOf(currentHandle);
    if (currentIndex == len - 1) {
        nextIndex = 0;
    } else {
        nextIndex = currentIndex + 1;
    }
    elem = $jq('.vg-quick-view:eq(' + nextIndex + ')');
    getProductInformation(productHandleArray[nextIndex], elem)

}

function getPrevProduct(currentHandle) {
    var prevIndex;
    var len = $jq('.vg-quick-view').length;
    var currentIndex = productHandleArray.indexOf(currentHandle);
    //alert("Current"+currentIndex)
    if (currentIndex == 0) {
        prevIndex = len - 1
    } else {
        prevIndex = currentIndex - 1;
    }
    elem = $jq('.vg-quick-view:eq(' + prevIndex + ')');
    getProductInformation(productHandleArray[prevIndex], elem)
}
function getProductInformation(handle, elem) {
  
    currentHandle = handle;
    $jq("#variantOptions").html('');
    var requestUrl = "/products/" + handle + ".js";
    $jq.getJSON(requestUrl, function (ProductData) {
        //alert(ProductData) 
        if(config.RatingProvider == "yotpo") {
            ProductData.reviewHtml = jQuery(elem).parent().parent().find('div.yotpo').wrapAll('<div>').parent().html();
         }
         if(config.RatingProvider == "shopify") {
         ProductData.reviewHtml = jQuery(elem).parent().parent().find('.spr-badge').wrapAll('<div>').parent().html();
         }
        ProductData.isVendorName = config.isVendorName;
        ProductData.siteUrl = window.location.origin;
        ProductData.isSocialShare = config.isSocialShare;
        ProductData.ShowInventory = config.ShowInventory;
        ProductData.metafieldData = jQuery(elem).parent().parent().find('.hidden-shopify-metafield').html();
        ProductData.price = ProductData.price / 100;
        ProductData.price = ProductData.price.toFixed(2);
        var tpl1 = '';

        tpl1 = JsonReqObbjData.mustache;
        var html1 = Mustache.render(tpl1, ProductData);
        var output = document.getElementById("ac__my__Modal");
        output.innerHTML = html1;
        $jq('.ac__my__Modal').css('height', config.containerHeight);
    	initiateZoom(config.ZoomType,ProductData.featured_image);
        $jq('.variant-quantity').text(ProductData.variants[0].inventory_quantity);
        var optionLength = ProductData.options.length;
        for (i = 0; i < optionLength; i++) {
            if (ProductData.options[i].name != "Title") {
                var selectWrapper = document.createElement("div");
                selectWrapper.setAttribute('class', 'selector-wrapper')
                var select = document.createElement("select");
                select.id = "opt-" + ProductData.options[i].name;
                select.setAttribute('onchange', "changeVariant(" + optionLength + ")");

                select.setAttribute('class', 'variant-options single-option-selector');
                for (j = 0; j < ProductData.options[i].values.length; j++) {
                    var optionVal = ProductData.options[i].values[j];
                    var option = document.createElement("option");
                    option.textContent = optionVal;
                    option.value = optionVal;
                    select.appendChild(option);
                }
                var lbls = document.createElement('label');
                lbls.innerHTML = ProductData.options[i].name;
                selectWrapper.appendChild(lbls)
                selectWrapper.appendChild(select)
                $jq("#AddToCartForm #qv-variant-outer").append(selectWrapper);
                // $jq("#variantOptions .col-md-12").append(select);
                var variantQuantity = ProductData.options[0].inventory_quantity;
                if (config.ShowInventory) {
                    $jq('.variant-quantity').text(variantQuantity);
                }
            } else {
                selectedVariantId = ProductData.variants[0].id;
            }
            $jq('#ac__my__Modal').show();

            $jq('#ac__my__Modal').on('shown', function () {
                alert("displaye")
            })

            //opens();
            //  changeVariant(optionLength);
        }
        changeVariant = function (optionLength) {
            setTimeout(function () {
                var selectedOptions = [];
                for (i = 0; i < optionLength; i++) {
                    selectedOptions[i] = $jq('.variant-options:eq(' + i + ')').val();
                }
                var difference = [];
                var variantPrice, price_max, variantQuantity;
                for (j = 0; j < ProductData.variants.length; j++) {
                    var array2 = ProductData.variants[j].options;
                    selectedOptions.sort();
                    array2.sort();
                    var is_same = selectedOptions.length == array2.length && selectedOptions.every(function (element, index) {
                        return element === array2[index];
                    });
                    //alert(is_same)
                    if (is_same == true) {
                        variantPrice = ProductData.variants[j].price / 100;
                        variantQuantity = ProductData.variants[j].inventory_quantity;
                        variantPrice = variantPrice.toFixed(2);

                        //ProductData.price=variantPrice;
                        $jq('.variant-price').text(variantPrice);
                        /* 
                         price_max = ProductData.variants[j].price_max / 100;
                         price_max = price_max.toFixed(2);
                        if (price_max != null && price_max != "NaN") {
                             $jq('.price_max').text(price_max);
                         } else {
                             $jq('.price_max').parent().remove();
                             $jq('.price_max').text("");
                         }*/

                        if (config.ShowInventory) {
                            $jq('.variant-quantity').text(variantQuantity);
                        }
                        selectedVariantId = ProductData.variants[j].id;
                        if (config.isVariantImageSwitch) {
                            console.log(ProductData.variants[j]);
                            var selectedVariantImage = ProductData.variants[j].featured_image.src;
                            initiateZoom(config.ZoomType, selectedVariantImage);
                        }
                    }
                }
            }, 1000)
        },
            ProductData.convertToCurrency = function () {
                return function (price, render) {
                    price = render(price);
                    price = price / 100;
                    price = price.toFixed(2);
                    return price;
                }
            },
            changeVariant(optionLength);

        try {
            quickViewOpenCallback();
        }
        catch (e) { }
    });
  
    
    setTimeout( function(){
      if(config.IsSocialShare){
        if(config.IsSocialShare_FB){
          $jq('.social__share__section #facebook__share').show();
        }
          if(config.IsSocialShare_Twitter){
          $jq('.social__share__section #twitter__share').show();
        }
          if(config.IsSocialShare_Linkedin){
          $jq('.social__share__section #linkedin__share').show();
        } 
          if(config.IsSocialShare_Pinterest){
          $jq('.social__share__section #pinterest__share').show();
        } 
      }
      if(config.VendorName){ 
        $jq('.vendor__section').show();
        }
      if(config.NextPreviousButtons) {
        $jq('.swap__right').show();
        $jq('.swap__left').show();
      }
    },1000);
}

$jq("#ac__my__Modal").on("hidden.bs.modal", function () {
    $jq('.zoomContainer').remove();
  });
 
function closeQuickView(){
$jq("#ac__my__Modal").hide();
}
function cartAdd() {
    var qty = $jq('.ac_qv_qty').val();
    Shopify.addItem(selectedVariantId, qty);
}

function changeMainImage(imgSrc) {
  console.log(imgSrc);
    initiateZoom(config.ZoomType, imgSrc);
}

function initiateZoom(ZoomType, imgSrc) {
    $jq('#feature_image').attr('src', imgSrc);
  setTimeout(function(){
    if (config.ImageZoom) {
        var ImageToZoom = $jq('#feature_image');
        $jq.removeData(ImageToZoom, 'elevateZoom'); //remove zoom instance from image
        $jq('.zoomContainer').remove(); // remove zoom container from DOM
        ImageToZoom.elevateZoom({
            zoomType: ZoomType,
            cursor: "crosshair", 
            scrollZoom: true
        });
    }
    },1000)
}



Shopify.onItemAdded = function (t) {
    if (config.OneClickCheckout == true) {
        window.location.href = "/checkout";
    } else {
        if (config.redirectToCart == false) {
            alert(t.title + " was added to your shopping cart.")
        } else {
            window.location.href = "/cart";
        }
    }
},
    Shopify.addItem = function (t, r, e, k, selectedCount) {
        var r = r || 1,
            a = {
                type: "POST",
                url: "/cart/add.js",
                data: "quantity=" + r + "&id=" + t,
                dataType: "json",
                async: false,
                success: function (t) {
                    "function" == typeof e ? e(t) : Shopify.onItemAdded(t, k, selectedCount)
                },
                error: function (t, r) {
                    Shopify.onError(t, r);
                }
            };
        jQuery.ajax(a);
    },
    Shopify.onError = function (t, r) {
        var e = eval("(" + t.responseText + ")");
        var tempMessage1 = e.description;
        var tempMessage2 = tempMessage1.split("more ");
        var message = tempMessage2[0] + "more than the available quantity of the " + tempMessage2[1];
        e.message ? alert(message) : alert("Error : " + Shopify.fullMessagesFromErrors(e).join("; ") + ".")
    }, Shopify.fullMessagesFromErrors = function (t) {
        var r = [];
        return jQuery.each(t, function (t, e) {
            jQuery.each(e, function (e, a) {
                r.push(t + " " + a)
            })
        }), r
    }
